import { Poll } from '@app/models/poll';
import { createAction, props } from '@ngrx/store';

// list received from the server (CustomMessageType.PlayerPolls) replaces the whole list
export const setAll = createAction('[Polls] Set All Polls', props<{ polls: Poll[] }>());
export const removeOne = createAction('[Polls] Remove One Poll', props<{ pollId: number }>());

export const vote = createAction('[Polls] Vote', props<{ pollId: number, option: number }>());
